export const hexToRgb = (
  hexString: string
): { r: number; g: number; b: number; toString: () => string } => {
  if (!/^#[0-9A-Fa-f]{6}$/i.test(hexString)) {
    throw new Error('Invalid hex string')
  }
  const cleanHexString = hexString.replace('#', '')
  const r = parseInt(cleanHexString.slice(0, 2), 16)
  const g = parseInt(cleanHexString.slice(2, 4), 16)
  const b = parseInt(cleanHexString.slice(4, 6), 16)
  return {
    r: r,
    g: g,
    b: b,
    toString: () => `rgba(${r}, ${g}, ${b}, 100)`,
  }
}

export const rgbToHex = (r: number, g: number, b: number): string => {
  if ([r, g, b].filter(v => v > 255 || v < 0).length) {
    throw new Error('Invalid RGB value')
  }
  return `#${[r, g, b]
    .map(v => v.toString(16).padStart(2, '0'))
    .join('')}`.toUpperCase()
}
